module.exports = __webpack_public_path__ + "static/media/fix_weld_1.eb492f39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/fix_weld_1.jpg
// module id = 1876
// module chunks = 0